import * as S from "./styled";

interface PropertyMapProps {
  readonly address: string;
}

export default function PropertyMap({ address }: PropertyMapProps) {
  return (
    <S.PropertyMap $photo={"/google_map_placeholder.png"} data-testid="property-map">
      <iframe
        title="Google Maps Embed"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_APP_GOOGLE_API_KEY}&q=${encodeURIComponent(address)}`}
      ></iframe>
    </S.PropertyMap>
  );
}
